import { withStyles } from '@mui/styles';
import { Box } from '@mui/material';
import { COLORS } from '../../../utils/Application_Constants';

const styles = () => ({
    tabPanel: {
        backgroundColor: COLORS.WHITE,
        borderRadius: '0 5px 5px 5px',
    },
});

function TabPanel({ children, value, index, classes, ...other }) {
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            className={classes.tabPanel}
            {...other}
        >
            {value === index && children}
        </div>
    );
}

export default withStyles(styles)(TabPanel);
